module.exports = {
  ADD_NEW_CONTACT_REQUEST: 'ADD_NEW_CONTACT_REQUEST',
  ADD_NEW_CONTACT_SUCCESS: 'ADD_NEW_CONTACT_SUCCESS',
  ADD_NEW_CONTACT_FAILURE: 'ADD_NEW_CONTACT_FAILURE',
  COPY_CONTACTS_REQUEST: 'COPY_CONTACTS_REQUEST',
  COPY_CONTACTS_SUCCESS: 'COPY_CONTACTS_SUCCESS',
  COPY_CONTACTS_FAILURE: 'COPY_CONTACTS_FAILURE',
  DELETE_CONTACT_REQUEST: 'DELETE_CONTACT_REQUEST',
  DELETE_CONTACT_SUCCESS: 'DELETE_CONTACT_SUCCESS',
  DELETE_CONTACT_FAILURE: 'DELETE_CONTACT_FAILURE',
  EDIT_CONTACT_REQUEST: 'EDIT_CONTACT_REQUEST',
  EDIT_CONTACT_SUCCESS: 'EDIT_CONTACT_SUCCESS',
  EDIT_CONTACT_FAILURE: 'EDIT_CONTACT_FAILURE',
  GET_ALL_IMPC_LOCATIONS_DEFAULT_REQUEST: 'GET_ALL_IMPC_LOCATIONS_DEFAULT_REQUEST',
  GET_ALL_IMPC_LOCATIONS_DEFAULT_SUCCESS: 'GET_ALL_IMPC_LOCATIONS_DEFAULT_SUCCESS',
  GET_ALL_IMPC_LOCATIONS_DEFAULT_FAILURE: 'GET_ALL_IMPC_LOCATIONS_DEFAULT_FAILURE',
  GET_ALL_DATA_LOCATIONS_DEFAULT_REQUEST: 'GET_ALL_DATA_LOCATIONS_DEFAULT_REQUEST',
  GET_ALL_DATA_LOCATIONS_DEFAULT_SUCCESS: 'GET_ALL_DATA_LOCATIONS_DEFAULT_SUCCESS',
  GET_ALL_DATA_LOCATIONS_DEFAULT_FAILURE: 'GET_ALL_DATA_LOCATIONS_DEFAULT_FAILURE',
  GET_CONTACT_DETAILS_REQUEST: 'GET_CONTACT_DETAILS_REQUEST',
  GET_CONTACT_DETAILS_SUCCESS: 'GET_CONTACT_DETAILS_SUCCESS',
  GET_CONTACT_DETAILS_FAILURE: 'GET_CONTACT_DETAILS_FAILURE',
  CHECK_EMAIL_ADDRESS_REQUEST: 'CHECK_EMAIL_ADDRESS_REQUEST',
  CHECK_EMAIL_ADDRESS_SUCCESS: 'CHECK_EMAIL_ADDRESS_SUCCESS',
  CHECK_EMAIL_ADDRESS_FAILURE: 'CHECK_EMAIL_ADDRESS_FAILURE',
  SET_CONTACT_GROUP: 'SET_CONTACT_GROUP',
  CLEAR_EMAIL_DUPLICATE: 'CLEAR_EMAIL_DUPLICATE',
};
